import { HttpClient } from 'src/app/modules/core';
import { UserListRequest, UserListResponse } from '../types/UserList';

class UserListService {
  private static instance: UserListService;
  private readonly http = HttpClient.getInstance();

  static getInstance() {
    if (!this.instance) this.instance = new UserListService();
    return this.instance;
  }

  async query(request: UserListRequest): Promise<UserListResponse> {
    const payload = {
      ...request,
      ...(request.filter ? { filter: request.filter } : {}),
      ...(request.cursor ? { cursor: request.cursor } : {}),
    };
    const response = await this.http.post<UserListResponse>('/v2/users/query', payload);
    if (!response.success || !response.data) {
      throw new Error(response.error || 'Failed to load users');
    }
    return response.data;
  }
}

export default UserListService;
